import React from "react";
import { makeStyles } from "@material-ui/core";

import sinDatos from "../../../../assets/images/sin-comunicaciones.png";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "5% 5% 0% 5%",
  },
});

const EmptyTable = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img src={sinDatos} alt="Sin servicios" />
      <p>No hay servicios</p>
    </div>
  );
};

export default EmptyTable as React.ComponentType;
